'use client';

import type { ReactNode } from 'react';

export function AuthGate({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
